import api from '@/api/api'
const state = {
  userInfo: null,
  freeNum: 20000,
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  getUserInfo({ commit }) {
    console.log('vuex用户=')
    api.getUserinfo().then(res => {
      if (res.code === 200) {
        commit('CHANGE_SETTING', { key: 'userInfo', value: res.data })
        commit('CHANGE_SETTING', { key: 'freeNum', value: res.data?.freeWordCount })
      } else {
        commit('CHANGE_SETTING', { key: 'userInfo', value: null })
        api.getGive().then(res => {
          if (res.code === 200) {
            commit('CHANGE_SETTING', { key: 'freeNum', value: res.data })
          }
        })
      }
    }).catch(() => {
      commit('CHANGE_SETTING', { key: 'userInfo', value: null })
      api.getGive().then(res => {
        if (res.code === 200) {
          commit('CHANGE_SETTING', { key: 'freeNum', value: res.data })
        }
      })
    })

  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

